export function getCurrentBackgroundColor(themeType, backgroundColor) {
    if (typeof backgroundColor === 'string') {
        return backgroundColor;
    }
    else if (backgroundColor && themeType) {
        return backgroundColor[themeType];
    }
    return undefined;
}
